import React from 'react';
import {Header, Breadcrumb, Segment,Container, Loader, Dropdown, Divider, Form, Dimmer, TextArea,   Button, Grid,Input, Radio} from 'semantic-ui-react';
import { Link } from "react-router-dom";


const TagForm=({ id, color, form, onSave,onChange, ajaxCallInProgress, datos, errors={}, strings, permisos})=>{

	return (
        <Container>
        <Dimmer.Dimmable   dimmed={ajaxCallInProgress>0?true:false}>
        <Segment basic>
				<Header  as='h2'   dividing>             
					<Header.Content>{strings?strings["Tag"]:""}</Header.Content>
				</Header>
			 
			<Grid container>
                <Grid.Row>
                    <Grid.Column >
                        <Form  >          
                            <Form.Field  required  error={errors.tag}>            
                              <label  >{strings?strings["Tag"]:""}</label>
                              <Input 
                                    placeholder={strings?strings["Tag"]:""} 
                                    name="descripcion"
                                    onChange={onChange}
                                    value={datos.descripcion}
                                    icon='edit'/>
                            </Form.Field>
                                                                        
                            <Divider hidden/>
							  <Grid centered>
                            <Button.Group  >
                                <Link to="/tags">
                                    <Button  
										 >{strings?strings["regresar"]:""}</Button>
                                </Link>
								  
                                <Button.Or text=" "></Button.Or>
								  
								  
                                <Button  color="black"
                                    onClick={onSave}>{strings?strings["guardar"]:""}
								 </Button>
								  
                              </Button.Group>
                            </Grid>
                           
                        </Form>
                    </Grid.Column>
                </Grid.Row>
                
            
            </Grid>
         <Dimmer active={ajaxCallInProgress>0?true:false} inverted>
          		<Loader size='big'  content={strings?strings["Procesando"]:""}/>
          </Dimmer>
        
        </Segment>
        </Dimmer.Dimmable>
        </Container>
	);
};



export default TagForm;